var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe',{staticClass:"my-swipe",attrs:{"autoplay":5000,"indicator-color":"#1baeae"}},_vm._l((_vm.list),function(item,index){return _c('van-swipe-item',{key:index},[_c('img',{attrs:{"src":item.image,"alt":""},on:{"click":function($event){return _vm.goTo(item.url)}}})])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24bf691a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swiper.vue
// module id = null
// module chunks = 